<p>
    Minos' Pond was a joint entry with a friend who did the art and sfx. It was
    my insane attempt to create a city builder resource management type game
    mixed with an Earthbound style overworld in 72 hours.
</p>
<p>
    This one didn't score too hot, probably because a high barrier to entry and
    generally unpleasant user experience. Still, the mechanics are pretty deep
    for the time span of development, and there is a charm to the Minos.
</p>
